import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import BreadCrumb from 'jbc-front/components/BreadCrumb';

import { SearchReactSelect } from 'src/components';
import { REPORT_INDEX, REPORT_LABOR_INSURANCE_DECLARATIONS } from 'src/constants/EndpointUrls';
import { LABOR_INSURANCE_SUMMARY_TYPES } from 'src/constants/Options';
import { extractCurrentQueries } from 'src/QueriesStorageApi';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { getListQueries, addQuery, addQueries } from 'src/reducers/common/listReducer';
import {
  REDUCER_NAME,
  fetchReportLaborInsurances,
  fetchReportLaborInsuranceDeclarationForm,
  changeUrl
} from 'src/reducers/reports/reportLaborInsurances';

import styles from './ReportLaborInsuranceList.scss';
import DeclarationForm from './components/DeclarationForm';
import SummaryList from './components/SummaryList';

const SelectSummaryType = ({ selectedSummaryType, handleOnClick }) => (
  <div className={styles.summaryTypeWrap}>
    {LABOR_INSURANCE_SUMMARY_TYPES.map((summaryType, index) => (
      <div
        className={summaryType.value === selectedSummaryType ? styles.summaryTypeBtnActive : styles.summaryTypeBtn}
        key={summaryType.value}
        active={summaryType.value === selectedSummaryType}
        onClick={e => {
          e.preventDefault();
          handleOnClick(summaryType);
        }}
        role="presentation"
      >
        <span className={styles.summaryTypeStep}>STEP.{index + 1}</span>
        {summaryType.label}
      </div>
    ))}
  </div>
);

class ReportLaborInsuranceList extends React.Component {
  constructor(props) {
    super(props);

    this.handleOnSelectSummaryType = this.handleOnSelectSummaryType.bind(this);

    this.state = {
      selectedSummaryType: this.props.location.pathname.indexOf(REPORT_LABOR_INSURANCE_DECLARATIONS) !== -1 ? '2' : '1'
    };
  }

  componentWillMount() {
    const { laborInsuranceYears } = this.props;
    const queriesCache = extractCurrentQueries(REDUCER_NAME);
    const { laborInsuranceYear = _.get(laborInsuranceYears, [0, 'value']) } = queriesCache;

    const queries = { ...queriesCache, laborInsuranceYear };

    if (!_.find(laborInsuranceYears, o => o.value === laborInsuranceYear)) {
      delete queries.laborInsuranceYear;
    }
    this.props.addQueries(queries);

    this.props.fetch();
  }

  handleOnSelectSummaryType(summaryType) {
    this.setState({
      ...this.state,
      selectedSummaryType: summaryType
    });
  }

  render() {
    const { queries, laborInsuranceYears, onChangeLaborInsuranceYear, changeLocation } = this.props;
    return (
      <div>
        <div className="l-wrap-xl l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label="書類作成" path={REPORT_INDEX} />
              <BreadCrumb.Item label="労働保険の年度更新" />
            </BreadCrumb>
          </div>
          <h1 className="m-title-main">労働保険の年度更新</h1>
          <div className={styles.selectYear}>
            <SearchReactSelect
              options={laborInsuranceYears}
              onChange={selected => {
                onChangeLaborInsuranceYear(selected.value);
                changeLocation(selected.value, this.state.selectedSummaryType);
              }}
              value={queries.laborInsuranceYear}
              size="large"
            />
          </div>
          <SelectSummaryType
            selectedSummaryType={this.state.selectedSummaryType}
            handleOnClick={e => {
              this.handleOnSelectSummaryType(e.value);
              changeLocation(queries.laborInsuranceYear, e.value);
            }}
          />

          {this.state.selectedSummaryType === '1' && <SummaryList laborInsuranceYear={queries.laborInsuranceYear} />}
          {this.state.selectedSummaryType === '2' && (
            <DeclarationForm laborInsuranceYear={queries.laborInsuranceYear} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  laborInsuranceYears: getSelectOptions(state, 'laborInsuranceYears'),
  queries: getListQueries(REDUCER_NAME, state)
});
const mapDispatchToProps = dispatch => ({
  addQueries: queries => {
    dispatch(addQueries(REDUCER_NAME, queries));
  },
  fetch: () => {
    dispatch(fetchReportLaborInsurances());
    dispatch(fetchReportLaborInsuranceDeclarationForm());
  },
  onChangeLaborInsuranceYear: query => {
    dispatch(addQuery(REDUCER_NAME, 'laborInsuranceYear', query));
    dispatch(fetchReportLaborInsurances());
    dispatch(fetchReportLaborInsuranceDeclarationForm());
  },
  changeLocation: (laborInsurnaceYear, summaryType) => {
    dispatch(changeUrl(laborInsurnaceYear, summaryType));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(ReportLaborInsuranceList);
